<div
  class="bottom-container tw-relative tw-flex tw-h-[2.25rem] tw-cursor-pointer tw-items-center tw-justify-center tw-uppercase"
  (click)="onButtonClick()"
>
  <div class="bottom-line tw-absolute tw-left-0 tw-top-full tw-h-[0.125rem] tw-w-full"></div>
  <div class="top-line tw-absolute tw-bottom-full tw-left-0 tw-h-[0.125rem] tw-w-full"></div>
  <div class="right-line tw-absolute tw-left-full tw-top-0 tw-h-full tw-w-[0.125rem]"></div>
  <div class="left-line tw-absolute tw-right-full tw-top-0 tw-h-full tw-w-[0.125rem]"></div>
  <ng-content></ng-content>
</div>
